import React from "react";
import queryString from 'query-string';
import { dataService } from '../_services/data.service'
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import * as moment from 'moment';


class CreditCardPage_ extends React.Component {

    constructor(props) {
        super(props);
        this.state = { notifyData: props.location.search, trxData: {}, params: {} };
        console.log(props);
    }

    componentDidMount() {
        let myUserString = sessionStorage.getItem('user');
        let myUser;
        try {
            myUser = JSON.parse(myUserString);
        } catch (e) {
            myUser = { token: '' };
        }


        let params = queryString.parse(this.state.notifyData);
        console.log("params");
        this.setState({ params });
        console.log(params);
        if (params.UniqueID) {
            dataService.getZCreditTransaction(params.UniqueID, myUser.token).then((data) => {
                this.setState({ trxData: data });
                console.log("trxData");
                console.log(this.state.trxData);
            })
        }

    }

    printReceipt = (e) => {
        e.preventDefault();
        window.print();
    }

    continueToDirectDebitBranches = (event) => {
        event.preventDefault();
        window.top.postMessage(
            JSON.stringify({
                error: false,
                message: this.state.trxData
            }),
            '*'
        );
    }


    render() {

        const items = []
        const { t } = this.props;
        const cityLogo = `./assets/imgs/${process.env.REACT_APP_LOGO}`;

        for (const [index, value] of Object.entries(this.state.trxData)) {
            items.push(<li key={index}>{index}:{value}</li>)
        }

        // PaymentSum:15.120000000000001
        // card_id:829210431
        // card_full_name:מגרש שחבק
        // employee:מגרש שחבק
        // item_list:100339995
        // item_type: 'invoice' or 'prepaid'
        // client_url_origin:http://localhost:3001
        // rest_url:http://localhost:3000
        // payment_no:145184
        // receipt_no:122179

        return (
            <div className="" ref={c => (this._this = c)}>
                <div className="container">
                    <div className="row">
                        {this.state.params.PaymentType === "authorize" &&
                            <div>
                                <h4>{this.props.t('dd_created_successfully') + ': ' + this.state.trxData.DD_NO} </h4>
                                <Link className="headerLink" to="" onClick={event => this.continueToDirectDebitBranches(event)}
                                >{this.props.t('define_branch_dd_detailes')}</Link>
                            </div>
                        }
                        {this.state.params.PaymentType !== "authorize" &&
                            <div className="receipt-main">
                                <div className="row">
                                    <div className="receipt-header">
                                        <img className="img-responsive" alt="city logo" src={cityLogo} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="receipt-header receipt-header-mid">

                                        <div className="receipt-right">
                                            <h4>{t('Dear')}:</h4>
                                            <h3>{this.state.trxData.card_full_name}</h3>
                                            <p>{this.state.trxData.card_id}</p>
                                        </div>
                                        <div className="receipt-left">
                                            <Link to="" onClick={this.printReceipt} >{t('print')}</Link>
                                            <p><b>תאריך :</b> {moment(Date()).format('DD/MM/YYYY')}</p>
                                            <h4>{t('Receipt_No') + ' ' + this.state.trxData.receipt_no} </h4>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <table className="receipt-table table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>{t('Description')}</th>
                                                <th>{t('Amount')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="col-md-9 text-right"><h5>{ (this.state.trxData.item_type === 'prepaid') ? t('Paid_counters') : t('Paid_invoices')}: {this.state.trxData.item_list} </h5></td>
                                                <td className="col-md-3 text-right"><h5>{parseFloat(this.state.trxData.PaymentSum).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</h5></td>
                                            </tr>
                                            <tr>
                                                <td className="col-md-9 text-right"><h5>{t('Payment_no')}: {this.state.trxData.payment_no} </h5></td>
                                                <td className="col-md-3 text-right"></td>
                                            </tr>
                                            <tr>
                                                <td className="col-md-9 text-right">&nbsp;</td>
                                                <td className="col-md-3 text-right"></td>
                                            </tr>
                                            <tr>
                                                <td className="col-md-9 text-right">&nbsp;</td>
                                                <td className="col-md-3 text-right"></td>
                                            </tr>
                                            <tr>
                                                <td className="text-right"><h2><strong>{t('Total')}: </strong></h2></td>
                                                <td className="text-left text-danger">
                                                    <h2><strong>{parseFloat(this.state.trxData.PaymentSum).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</strong></h2>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="row">
                                    <div className="receipt-footer-left">
                                        <h5 style={{ color: '#8c8c8c', margin: '50px 30px' }}>תודה רבה</h5>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}


const CreditCardPage = withTranslation()(CreditCardPage_);

export { CreditCardPage, CreditCardPage_ };

